import {ModuleWithProviders, NgModule} from '@angular/core';
import {SelectionSupportComponent} from "./tools/selection-support/SelectionSupport";
import {TranslatePoolSupportComponent} from "./tools/translate-pool-support/translate-pool-support.component";
import {SafeHtmlPipe} from "./pipes/safe-html.pipe";
import {TableFilterPipe} from "./pipes/table-filter.pipe";
import {HttpClient} from "@angular/common/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {NzGridModule} from "ng-zorro-antd/grid";
import {NzTreeModule} from "ng-zorro-antd/tree";
import {NzToolTipModule} from "ng-zorro-antd/tooltip";
import {NzIconModule} from "ng-zorro-antd/icon";
import {NzTagModule} from "ng-zorro-antd/tag";
import {NzDropDownModule} from "ng-zorro-antd/dropdown";
import {NzAlertModule} from "ng-zorro-antd/alert";
import {NzSelectModule} from "ng-zorro-antd/select";
import {NzInputNumberModule} from "ng-zorro-antd/input-number";
import {NzTreeSelectModule} from "ng-zorro-antd/tree-select";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzEmptyModule} from "ng-zorro-antd/empty";
import {NzTableModule} from "ng-zorro-antd/table";
import {NzSwitchModule} from "ng-zorro-antd/switch";
import {NzInputModule} from "ng-zorro-antd/input";
import {NzTabsModule} from "ng-zorro-antd/tabs";
import {NzLayoutModule} from "ng-zorro-antd/layout";
import {NzFormModule} from "ng-zorro-antd/form";
import {NzPopconfirmModule} from "ng-zorro-antd/popconfirm";
import {NzDescriptionsModule} from "ng-zorro-antd/descriptions";
import {NzSpinModule} from "ng-zorro-antd/spin";
import {NzRadioModule} from "ng-zorro-antd/radio";
import {NzCheckboxModule} from "ng-zorro-antd/checkbox";
import {NzDatePickerModule} from "ng-zorro-antd/date-picker";
import {NzPopoverModule} from "ng-zorro-antd/popover";
import {NzListModule} from "ng-zorro-antd/list";
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import {FunctionManagementComponent} from "./components/admin/function-management/function-management.component";
import {OrganizationDepartmentManagementComponent} from "./components/admin/organization-department-management/organization-department-management.component";
import {RolePrivilegeManagementComponent} from "./components/admin/role-privilege-management/role-privilege-management.component";
import {PiResourceDetailViewerComponent} from "./components/common/pi-resource-detail-viewer/pi-resource-detail-viewer.component";
import {PermissionToolkitService} from "./services/permission-toolkit.service";
import {StorageService} from "./services/storage.service";
import {SysDataModelService} from "./services/system/sys-data-model.service";
import {SysUiDisplayService} from "./services/system/sys-ui-display.service";
import {TagService} from "./services/tag/tag.service";
import {AuthenticationService} from "./services/utils/authentication.service";
import {PiDataTableComponent} from "./components/common/pi-data-table/pi-data-table.component";
import {PiNavigationMenuComponent} from "./components/common/pi-navigation-menu/pi-navigation-menu.component";
import {GeneralSearchToolComponent} from "./components/search-tool/general-search-tool/general-search-tool.component";
import {SearchConditionBuilderComponent} from "./components/search-tool/search-condition-builder/search-condition-builder.component";
import {TagSelectorComponent} from "./components/tag/tag-selector/tag-selector.component";
import {TaskStatusViewerComponent} from "./components/common/task-status-viewer/task-status-viewer.component";
import {PrivilegeCheckDirective} from "./directives/privilege-check.directive";
import {TagPickerComponent} from "./components/tag/tag-picker/tag-picker.component";
import { LocationPickerComponent } from './components/common/location-picker/location-picker.component';
import {NzProgressModule} from "ng-zorro-antd/progress";
import {DragDropModule} from "@angular/cdk/drag-drop";
import { EntityManagementSupportComponent } from './tools/entity-management-support/entity-management-support.component';
import { PreferenceService } from './services/system/preference.service';
import { PiCustomFieldComponent } from './components/common/pi-custom-field/pi-custom-field.component';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzUploadModule } from 'ng-zorro-antd/upload';

export function createTranslateHttpLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    EntityManagementSupportComponent,
    SelectionSupportComponent,
    TranslatePoolSupportComponent,
    FunctionManagementComponent,
    OrganizationDepartmentManagementComponent,
    RolePrivilegeManagementComponent,
    SafeHtmlPipe,
    TableFilterPipe,
    PrivilegeCheckDirective,
    PiResourceDetailViewerComponent,
    GeneralSearchToolComponent,
    SearchConditionBuilderComponent,
    TagSelectorComponent,
    TagPickerComponent,
    TaskStatusViewerComponent,
    PiDataTableComponent,
    PiCustomFieldComponent,
    PiNavigationMenuComponent,
    LocationPickerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateHttpLoader),
        deps: [HttpClient]
      }
    }),
    DragDropModule,
    NzGridModule,
    NzTreeModule,
    NzToolTipModule,
    NzIconModule,
    NzTagModule,
    NzDropDownModule,
    NzAlertModule,
    NzSelectModule,
    NzInputNumberModule,
    NzTreeSelectModule,
    NzButtonModule,
    NzEmptyModule,
    NzTableModule,
    NzSwitchModule,
    NzInputModule,
    NzTabsModule,
    NzLayoutModule,
    NzFormModule,
    NzPopconfirmModule,
    NzDescriptionsModule,
    NzSpinModule,
    NzRadioModule,
    NzCheckboxModule,
    NzDatePickerModule,
    NzPopoverModule,
    NzListModule,
    NzTypographyModule,
    NzProgressModule,
    NzTimePickerModule,
    NzUploadModule
  ],
  exports: [
    EntityManagementSupportComponent,
    SelectionSupportComponent,
    TranslatePoolSupportComponent,
    FunctionManagementComponent,
    OrganizationDepartmentManagementComponent,
    RolePrivilegeManagementComponent,
    SafeHtmlPipe,
    TableFilterPipe,
    GeneralSearchToolComponent,
    SearchConditionBuilderComponent,
    PiResourceDetailViewerComponent,
    TaskStatusViewerComponent,
    TagSelectorComponent,
    TagPickerComponent,
    PrivilegeCheckDirective,
    PiDataTableComponent,
    PiCustomFieldComponent,
    PiNavigationMenuComponent,
    LocationPickerComponent
  ]
})

export class FrontCommonToolkitsModule {
  static forRoot(configuration?): ModuleWithProviders<FrontCommonToolkitsModule> {
    console.log('FrontCommonToolkitsModule configuration', configuration);
    return {
      ngModule: FrontCommonToolkitsModule,
      providers: [
        AuthenticationService,
        PermissionToolkitService,
        StorageService,
        SysDataModelService,
        SysUiDisplayService,
        TagService,
        StorageService,
        {provide: 'httpBaseSettings', useValue: configuration},
        {provide: PreferenceService}
      ]
    };
  }
}
